const PropertyTypes = [
    // Kategori: Hotel
    { value: 'apart_hotel', label: 'Apart Hotel', category: 'Hotel' },
    { value: 'camping', label: 'Camping', category: 'Hotel' },
    { value: 'capsule_hotel', label: 'Capsule Hotel', category: 'Hotel' },
    { value: 'guest_house', label: 'Guest House', category: 'Hotel' },
    { value: 'holiday_park', label: 'Holiday Park', category: 'Hotel' },
    { value: 'hostel', label: 'Hostel', category: 'Hotel' },
    { value: 'hotel', label: 'Hotel', category: 'Hotel' },
    { value: 'inn', label: 'Inn', category: 'Hotel' },
    { value: 'lodge', label: 'Lodge', category: 'Hotel' },
    { value: 'motel', label: 'Motel', category: 'Hotel' },
    { value: 'resort', label: 'Resort', category: 'Hotel' },
    { value: 'riad', label: 'Riad', category: 'Hotel' },
    { value: 'ryokan', label: 'Ryokan', category: 'Hotel' },
    { value: 'tent', label: 'Tent', category: 'Hotel' },

    // Kategori: Vacation Rental
    { value: 'apartment', label: 'Apartment', category: 'Vacation Rental' },
    { value: 'boat', label: 'Boat', category: 'Vacation Rental' },
    { value: 'chalet', label: 'Chalet', category: 'Vacation Rental' },
    { value: 'country_house', label: 'Country House', category: 'Vacation Rental' },
    { value: 'farm_stay', label: 'Farm Stay', category: 'Vacation Rental' },
    { value: 'holiday_home', label: 'Holiday Home', category: 'Vacation Rental' },
    { value: 'homestay', label: 'Homestay', category: 'Vacation Rental' },
    { value: 'villa', label: 'Villa', category: 'Vacation Rental' },
];

export default PropertyTypes;